import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const getDbReleaseFlow = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/',
    params: params,
    method: 'get'
  })
}

export const detailDbReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteDbReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/' + id + '/',
    method: 'delete'
  })
}

export const dbReleaseFlowApplySql = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/apply_sql/',
    data: data,
    method: 'post'
  })
}

export const dbReleaseFlowApplyNewUser = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/apply_new_user/',
    data: data,
    method: 'post'
  })
}
export const dbReleaseFlowApplyPrivilege = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/apply_privilege/',
    data: data,
    method: 'post'
  })
}

export const refuseDbReleaseFlow = (id, content) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/' + id + '/refuse/',
    data: { content: content },
    method: 'post'
  })
}

export const executeDbReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_application_flow/' + id + '/execute/',
    method: 'post'
  })
}

// 按类别（执行SQL/新建用户等）、时间维度 统计数量
export const getDbType = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_type/',
    params: params,
    method: 'get'
  })
}

// 按实例统计执行数量
export const getDbInstance = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_show_instance/',
    params: params,
    method: 'get'
  })
}

// 按项目统计每月执行数（可自定义时间节点）
export const getDbMon = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_show_mon/',
    params: params,
    method: 'get'
  })
}

// 按项目统计每月执行数（可自定义时间节点）
export const getDbShowStatus = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_show_status/',
    params: params,
    method: 'get'
  })
}

// Top10
export const getDbTop = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_top/',
    params: params,
    method: 'get'
  })
}
